import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setCityName } from "../../store/citySlice";
import { useLocation } from 'react-router-dom';
import {
  getCartTotal,
  removeItem,
  decreaseItemQuantity,
  increaseItemQuantity,
} from "../../store/cartSlice";

const ViewCartComponent = ({setCartList, setConfirmForm}) => {
  const handleClose = () => {
        setCartList(false)

  };

  const [priceAlert , setPriceAlert]= useState(false)
  const [greenAlrt, setGreenAlrt]= useState(false)
    
    
    const { cart, totalQuantity, totalPrice } = useSelector(
      (state) => state.allCart
    );

    const dispatch = useDispatch();


    
// location Update :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const selectedCity = useSelector((state) => state.city.cityName);
  const handleChange = (e) => {
    const newCity = e.target.value;
    dispatch(setCityName(newCity)); 
  };







const location = useLocation();
// console.log(location.pathname);













  // ::::::::Package Booking Limit :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  
    useEffect(() => {
      dispatch(getCartTotal());
    }, [cart]);




// Update Ammount Based on Condition :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
 // const minAmount = 999;
  const [minAmount , setMinAmmount] = useState(999)

useEffect(()=>{


   if(location.pathname === "/nail-art-delhi-ncr"){
    setMinAmmount(599)
    if(totalPrice < 599){
      setPriceAlert(true)
    }
    if(totalPrice > 599){
      setPriceAlert(false)
    }
    return; 
  }




  if(selectedCity === "Noida"){

    if(location.pathname === "/salon-for-women-at-home"){
      setMinAmmount(9)
    }else{
      setMinAmmount(1599)
    }


  if(totalPrice <1599){
    setPriceAlert(true)
  } 
  if(totalPrice >1599){
    setPriceAlert(false)
  
  }
  }

  if(selectedCity === "Gurgaon"){

   if(location.pathname === "/salon-for-women-at-home"){
    setMinAmmount(9)
   }else{
     setMinAmmount(2198)
   }
    
  if(totalPrice <2198){
    setPriceAlert(true)
  } 
  if(totalPrice >2198){
    setPriceAlert(false)
  }
  }

    if(selectedCity === "Delhi"){
          if(location.pathname === "/salon-for-women-at-home"){
              setMinAmmount(9)
          }else{

            setMinAmmount(2198)
          }
    
  if(totalPrice < 2198){
    setPriceAlert(true)
  } 
  if(totalPrice >2198){
    setPriceAlert(false)
  }
  }


 if(selectedCity === "Greater Noida"){
      if(location.pathname === "/salon-for-women-at-home"){
setMinAmmount(9)
      }else{
        setMinAmmount(2198)
      }
    
  if(totalPrice <2198){
    setPriceAlert(true)
  } 
  if(totalPrice >2198){
    setPriceAlert(false)
  }
  }



 if(selectedCity === "Ghaziabad"){
      if(location.pathname === "/salon-for-women-at-home"){
        setMinAmmount(9)
      }else{
        setMinAmmount(2198)
      }
    
  if(totalPrice <2198){
    setPriceAlert(true)
  } 
  if(totalPrice >2198){
    setPriceAlert(false)
  }
  }

   if(selectedCity === "Faridabad"){
    
        if(location.pathname === "/salon-for-women-at-home"){
          setMinAmmount(9)
        }else{

          setMinAmmount(2198)
        }
    
  if(totalPrice <2198){
    setPriceAlert(true)
  } 
  if(totalPrice >2198){
    setPriceAlert(false)
  }
  }


     if(selectedCity === "Chandigarh"){
    
        if(location.pathname === "/salon-for-women-at-home"){
          setMinAmmount(9)
        }else{

          setMinAmmount(2198)
        }
    
  if(totalPrice <2198){
    setPriceAlert(true)
  } 
  if(totalPrice >2198){
    setPriceAlert(false)
  }
  }


     if(selectedCity === "Others"){

          if(location.pathname === "/salon-for-women-at-home"){
            setMinAmmount(9)
          }else{

            setMinAmmount(2198)
          }
    
  if(totalPrice <2198){
    setPriceAlert(true)
  } 
  if(totalPrice >2198){
    setPriceAlert(false)
  }
  }


},[selectedCity, totalPrice])


















  return (
    <div>
      <div className="view-cart">
        <div className="view-cart-close" onClick={handleClose}></div>

        <div className="view-cart-main">
          <div className="view-cart-top">
            <div></div>
            <div>MY CART</div>
            <span onClick={handleClose}>CLOSE</span>
          </div>

          <div className="view-cart-content">

            {
                cart?.map( e => (
            <div className="view-cart-list">
              <div className="view-cart-head">
                <div>{e.fullName ? <span> {e.fullName}</span>: <span> {e.serviceName}</span> }</div>
                <span>
                  <i onClick={() => dispatch(removeItem(e._id))} class="fa-solid fa-trash-can"></i>
                </span>
              </div>
              <div className="view-cart-value">
                <div className="view-cart-quantity">
                    {
                        e.quantity <=1?
                  <div className="view-cart-quantity-disable">-</div>
                  :
                  <div className="view-cart-quantity" onClick={() =>
                                                      dispatch(decreaseItemQuantity(e._id))
                                                    }>-</div>
                    }
                  <span>{e.quantity}</span>
                  {
                    e.quantity <=9?
                  
                  <div  onClick={() =>
                                                    dispatch(increaseItemQuantity(e._id))
                                                  }>+</div>
                                                  :
                  <div className="view-cart-quantity-disable">+</div>

                                                }
                </div>
                <div className="view-cart-price">₹ {e.price}</div>
              </div>
            </div>

                ))

            }

          
          </div>

          <div className="view-cart-end">
{priceAlert && totalPrice<minAmount ?  <div className='package-alert'> <div className='package-alert-2 package-alert-animation' >               <div className="view-cart-limit-text"> <i class="fa-solid fa-bell"></i> Add services worth <b>₹{minAmount-totalPrice}</b> to complete order</div>
</div></div> :  "" }

            {
                totalPrice<minAmount?

                        <div className="view-cart-limit">
              {/* <div className="view-cart-limit-text">Add services worth <b>₹{minAmount-totalPrice}</b> to complete order</div> */}
              <div className="view-cart-limit-bar">
                <div
                  style={{ width: `${(totalPrice / minAmount) * 100}%` }}
                ></div>
              </div>
              <div className="view-cart-limit-head">
                <div>Salon At Home</div>
                <div>₹{totalPrice} / ₹{minAmount}</div>
              </div>
            </div>
            :""}

            <div className="view-cart-total">
              <span>Cart Subtotal :</span>
              <div>₹ {totalPrice}</div>
            </div>
            <div>

{/* :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}


{


  selectedCity !== null ?

          <div className='view-card-list-selected-location'>


          <div>Selected Location:</div>
          <div>

          <select value={selectedCity} onChange={handleChange}>
          <option value="Delhi">Delhi</option>
          <option value="Noida">Noida</option>
       
            <option value="Gurgaon">Gurgaon</option>
            {/* <option value="Chandigarh">Chandigarh</option> */}
          
         <option value="Greater Noida">Greater Noida</option>
         <option value="Ghaziabad">Ghaziabad</option>
          <option value="Faridabad">Faridabad</option>

         {/* <option value="Others">Others</option> */}


          </select>

          </div>


          </div>
  :""
}



            </div>

            {
                totalPrice<minAmount?
                <div className="view-cart-button-disable">Proceed to Checkout</div>
                :
            <div className="view-cart-button"  onClick={e=> setConfirmForm(true)}> Proceed to Checkout</div>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCartComponent;
